/* Add to Calendar's menu, in the telify layer so a custom site's own rules win; the box follows the
   website header's account menu. Theme tokens only; the website's --line and --r-ctl where it sets them. */
@layer telify {
  .wrap {
    position: relative;
    display: inline-flex;
  }

  .menu {
    position: absolute;
    right: 0;
    top: calc(100% + 8px);
    width: 200px;
    padding: 6px 0;
    display: flex;
    flex-direction: column;
    background: var(--bg-page);
    border: var(--line, 1px solid var(--border-soft));
    border-radius: var(--r-ctl, 10px);
    box-shadow: var(--shadow-card);
    z-index: 40;
  }

  .item {
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    background: none;
    width: 100%;
    cursor: pointer;
    display: flex;
    padding: 11px 18px;
    font: inherit;
    font-size: 15px;
    color: var(--text-primary);
    text-align: left;
    text-decoration: none;
  }

  @media (hover: hover) {
    .item:hover {
      background: rgba(var(--fg-page-rgb), 0.05);
    }
  }
}
